/**********************************************************************
// @@@ START COPYRIGHT @@@
//        AVI SOLAR ENERGY CONFIDENTIAL: NEED TO KNOW ONLY
//        Copyright 2018 - 2019
//        Avi Solar Energy Pvt Ltd.
//        Protected as an unpublished work.
//  The computer program listings, specifications and documentation
//  herein are the property of Avi Solar Energy Pvt Ltd., or a third party supplier
//  and shall not be reproduced, copied, disclosed, or used in whole or in part for
//  any reason without the prior express written permission of Avi Solar Energy Pvt Ltd.
// @@@ END COPYRIGHT @@@
// +++ Code modified on 2019/02/25
**********************************************************************/
<template>
<v-flex md12 class="table">
  <v-card>
      <v-toolbar height="44px" class="sub-header hidden-sm-and-down">
      <v-toolbar-title class="body-2">Plant Details</v-toolbar-title>
      <v-spacer></v-spacer>
      <input v-model="search" placeholder="Search" class="right-space" />
      <v-tooltip top>
        <v-btn flat icon slot="activator" v-on:click="refresh">
          <v-avatar :tile="tile" :size="avatarSize" class="avatar-bg">
            <v-icon>cached</v-icon>
          </v-avatar>
        </v-btn>
        <span>Refresh</span>
      </v-tooltip>

      <v-tooltip top>
        <v-btn flat icon slot="activator" class="right-space" v-on:click="download">
          <v-avatar :tile="tile" :size="avatarSize" class="avatar-bg">
            <v-icon>insert_drive_file</v-icon>
          </v-avatar>
        </v-btn>
        <span>Download CSV</span>
      </v-tooltip>
    </v-toolbar>
    <!-- agathsya code starts here  -->
    <v-toolbar height="48px" class="hidden-md-and-up ag-home">
      <v-toolbar-title class="body-2 ag-body-2">Daily Updates</v-toolbar-title>
      <v-spacer></v-spacer>
      <input
        placeholder="Search"
        v-on:input="search = $event.target.value"
        class="right-space ag-home-input"
      />
      <v-tooltip top>
        <v-btn flat icon slot="activator" v-on:click="refresh" class="ag-home-refresh">
          <v-avatar :tile="tile" :size="avatarSize" class="avatar-bg">
            <v-icon class="refresh-icon">cached</v-icon>
          </v-avatar>
        </v-btn>
        <span>Refresh</span>
      </v-tooltip>
    </v-toolbar>
    <div class="legend-background hidden-md-and-up ag-info">
      <v-btn class="legend ag-info-btn" xs6 sm3 md3 lg3 xl3 color="red" fab small></v-btn>
      <span class="ag-info-name">New Alerts</span>
      <!-- <v-btn class="legend ag-info-btn" xs6 sm3 md3 lg3 xl3 color="warning" fab small></v-btn>
      <span class="ag-info-name">Acknowledged</span>-->
      <!-- </div>
      <div class="legend-background hidden-sm-and-up ag-info">-->
      <v-btn class="legend ag-info-btn" xs6 sm3 md3 lg3 xl3 color="success" fab small></v-btn>
      <span class="ag-info-name">No Alerts</span>
      <!-- <v-btn class="legend ag-info-btn" xs6 sm3 md3 lg3 xl3 color="grey" fab small></v-btn>
      <span class="ag-info-name">Not Connected</span>-->
    </div>

    <v-data-table
      class="plant-datatable hidden-md-and-up"
      :headers="header"
      :items="data"
      :search="search"
      id="table"
      hide-actions
      :loading="dataLoading"
      :custom-sort="sortByNum"
    >
      <v-alert
        id="search"
        slot="no-results"
        :value="true"
        color="ag-white"
        icon="warning"
      >Your search for "{{ search }}" found no results.</v-alert>
    </v-data-table>
    <!-- agathsya code ends here  -->
    <!-- <v-data-table :headers="header" :items="data" :search="search" :rows-per-page-items="rowsPerPage" id="table" :loading="dataLoading" :custom-sort="sortByNum"> -->

    <v-data-table
      class="plant-datatable hidden-sm-and-down"
      :headers="header"
      :items="data"
      :search="search"
      id="table"
      hide-actions
      :loading="dataLoading"
      :custom-sort="sortByNum"
    >
      <template slot="items" slot-scope="props">
        <tr>
          <td>{{ props.item.cust_id}}</td>
          <td>{{ props.item.customer_name}}</td>
          <td>{{ props.item.plant_id}}</td>
          <td>{{ props.item.plant_name}}</td>
          <td>{{ props.item.dc_capacity}}</td>
          <td>
            <span v-if="props.item.commission_date==null">-</span>
            <span v-else>{{props.item.commission_date}}</span>
          </td>
          <td>
            <!-- <span v-if="props.item.expiry_date == null">-</span> -->
            <span>{{props.item.expiry_date}}</span>
          </td>
          <td>
            <span v-if="props.item.renew_date==null">-</span>
            <span v-else>{{props.item.renew_date}}</span>
          </td>
        </tr>
      </template>

      <v-alert
        id="search"
        slot="no-results"
        :value="true"
        color="error"
        icon="warning"
      >Your search for "{{ search }}" found no results.</v-alert>
    </v-data-table>

    <div class="legend-background hidden-sm-and-down">
    </div>
  </v-card>
  </v-flex>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import axios from 'axios'
import Home from '@/services/Home'
import { mixin, mapGettersMixin } from '@/util/mixin/index'
var moment = require('moment')

export default {
  props: ['theme'],
  mixins: [ mixin, mapGettersMixin ],
  data() {
    return {
      rowsPerPage: [
        {
          text: '10',
          value: 3
        }
      ],
      pagination: {},
      search: '',
      data: [],
      slider: 32,
      tile: false,
      param: {
        plantList: []
      },
      dataLoading: false
    }
  },
  created() {
    axios.defaults.headers.common['Authorization'] =
      'Bearer ' + this.$session.get('jwt')
    this.getPlantDetails()
  },
  mounted() {
    // Set row per page
    let dataLength = this.getTotalPlantCount
    let rows = 10
    let index = 1
    this.rowsPerPage[0].text = dataLength < rows ? dataLength + '' : rows + ''
    this.rowsPerPage[0].value = dataLength < rows ? dataLength : rows
    if (dataLength < rows) {
      this.rowsPerPage.splice(0, 0, dataLength)
    }
    while (dataLength >= rows) {
      this.rowsPerPage.splice(index++, 0, rows)
      rows += 10
    }
    if (dataLength > this.rowsPerPage[index - 1]) {
      this.rowsPerPage.splice(index, 0, dataLength)
    }

    let plantList = this.getPlantList.map(el => el.id)
    plantList.forEach(element => {
      this.param.plantList.push(
        element + (this.isV2(element, 'home') ? '-v2' : '')
      )
    })
    this.setIntervalWithoutDelay(this.callAllApi)
  },
  computed: {
    ...mapGetters([
      'getTotalPlantCount',
      'getPlantList',
      'isV2',
      'getRules',
      'getSelectedPlantId'
    ]),
    avatarSize() {
      return `${this.slider}px`
    },
    header() {
      var head = [
        {
          text: 'Customer ID',
          align: 'left',
          value: 'cust_id'
        },
        {
          text: 'Customer Name',
          value: 'customer_name'
        },
        {
          text: 'Plant ID',
          value: 'plant_id'
        },
        {
          text: 'Plant Name',
          align: 'left',
          value: 'plant_name',
          width: '210px'
        },
        {
          text: 'Plant Capacity',
          value: 'dc_capacity'
        },
        {
          text: 'Commission Date',
          value: 'commission_date'
        },
        {
          text: 'Expiry Date',
          value: 'expiry_date'
        },
        {
          text: 'Renew Date',
          value: 'renew_date'
        }
      ]
      return head
    },
    pages () {
      if (this.pagination.rowsPerPage == null ||
          this.pagination.totalItems == null
      ) return 0

      return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
    }
  },
  watch: {
    isReload() {
      if (this.isReload) {
        this.setIntervalWithoutDelay(this.callAllApi)
      }
    }
  },
  methods: {
    ...mapMutations([
      'SET_SELECTED_PLANT_ID',
      'SET_SELECTED_COMPONENT_MENU',
      'SET_LAST_CALL_TIME'
    ]),
    callAllApi() {
      let updateTime = moment().format('MM-DD-YYYY H:mm:ss')
      this.SET_LAST_CALL_TIME(updateTime)
      this.getPlantDetails()
    },
    sortByNum(item, index, isDesc) {
      function numericCompare(a, b) {
        if (isDesc === true) {
          if (
            parseFloat(a[index].toString().replace(/,/gi, '')) <
            parseFloat(b[index].replace(/,/gi, ''))
          ) {
            return -1
          }
          if (
            parseFloat(a[index].toString().replace(/,/gi, '')) >
            parseFloat(b[index].toString().replace(/,/gi, ''))
          ) {
            return 1
          }
        } else if (isDesc === false) {
          if (
            parseFloat(a[index].toString().replace(/,/gi, '')) >
            parseFloat(b[index].toString().replace(/,/gi, ''))
          ) {
            return -1
          }
          if (
            parseFloat(a[index].toString().replace(/,/gi, '')) <
            parseFloat(b[index].toString().replace(/,/gi, ''))
          ) {
            return 1
          }
        }
        return 0
      }

      function stringCompare(a, b) {
        if (isDesc === true) {
          if (a[index] < b[index]) {
            return -1
          }
          if (a[index] > b[index]) {
            return 1
          }
        } else if (isDesc === false) {
          if (a[index] > b[index]) {
            return -1
          }
          if (a[index] < b[index]) {
            return 1
          }
        }
        return 0
      }

      function prSort(a, b) {
        if (isDesc === true) {
          // if(a[index] === b[index])
          //   return 0
          if (typeof a[index] === typeof b[index]) {
            return a[index] < b[index] ? -1 : 1
          }
          return typeof a[index] > typeof b[index] ? -1 : 1
        } else if (isDesc === false) {
          // if(a[index] === b[index])
          //   return 0
          if (typeof a[index] === typeof b[index]) {
            return a[index] > b[index] ? -1 : 1
          }
          return typeof a[index] < typeof b[index] ? -1 : 1
        }
        return 0
      }
      if (index === 'cust_id') {
        return item.sort(numericCompare)
      } else if (index === 'customer_name') {
        return item.sort(stringCompare)
      } else if (index === 'plant_id') {
        return item.sort(numericCompare)
      } else if (index === 'plant_name') {
        return item.sort(stringCompare)
      } else if (index === 'dc_capacity') {
        return item.sort(numericCompare)
      } else if (index === 'commission_date') {
        return item.sort(prSort)
      } else if (index === 'renew_date') {
        return item.sort(prSort)
      } else if (index === 'expiry_date') {
        return item.sort(prSort)
      } else {
        return item
      }
    },

    getPlantDetails: async function() {
      let res = await Home.getPlantDetails()
      console.log('res', res)
      res.data.forEach(el => {
        let temp = {}
        temp['cust_id'] = el.cust_id
        temp['customer_name'] = el.customer_name
        temp['plant_id'] = el.plant_id
        temp['plant_name'] = el.plant_name
        temp['dc_capacity'] = el.dc_capacity
        temp['commission_date'] = el.commission_date
        temp['expiry_date'] = el.expiry_date
        temp['renew_date'] = el.renew_date
        this.data.push(temp)
      })
    },
    refresh() {
      this.data.length = 0
      this.setIntervalWithoutDelay(this.callAllApi)
    },
    selectPlant(plantId, plantName) {
      this.SET_SELECTED_PLANT_ID(plantId)
      this.SET_SELECTED_COMPONENT_MENU('plantOverview')
      let path = this.getRules(['rule', 'access_config'])
        ? this.getRules(['rule', 'access_config', 'plantOverview', 'path'])
        : '/plantOverview'
      this.$router.push(path)
    },
    rowsPerPageList() {
      let dataLength = this.data.length
      let rows = 10
      while (dataLength < rows) {
        this.rowsPerPage.push(rows)
        rows += 10
      }
      this.rowsPerPage.push(dataLength)
    },
    download() {
      if (this.data.length === 0) {
      } else {
        this.JSONToCSVConvertor(this.data, 'Plant Report', false)
      }
    },
    JSONToCSVConvertor(JSONData, ReportTitle, ShowLabel) {
      // If JSONData is not an object then JSON.parse will parse the JSON string in an Object
      var arrData =
        typeof JSONData !== 'object' ? JSON.parse(JSONData) : JSONData

      var CSV = ''
      // Set Report title in first row or line

      let header =
        'CUSTOMER ID, CUSTOMER NAME, PLANT ID, PLANT NAME, PLANT CAPACITY, COMMISSION DATE, EXPIRY DATE, RENEW DATE'
      let headerOrder = [
        'cust_id',
        'customer_name',
        'plant_id',
        'plant_name',
        'dc_capacity',
        'commission_date',
        'expiry_date',
        'renew_date'
      ]
      // This condition will generate the Label/Header
      if (ShowLabel) {
        let row = ''

        // This loop will extract the label from 1st index of on array
        for (let index in arrData[0]) {
          // Now convert each value to string and comma-seprated
          row += index + ','
        }
        row = row.slice(0, -1)

        // append Label row with line break
        CSV += row + '\r\n'
      }
      CSV += header + '\r\n'

      // 1st loop is to extract each row
      for (var i = 0; i < arrData.length; i++) {
        let row = ''
        // 2nd loop will extract each column and convert it in string comma-seprated
        for (var index in headerOrder) {
          row += '"' + arrData[i][headerOrder[index]] + '",'
        }
        row.slice(0, row.length - 1)

        // add a line break after each row
        CSV += row + '\r\n'
      }

      if (CSV === '') {
        alert('Invalid data')
        return
      }

      // Generate a file name
      var fileName = 'MyReport_'
      // this will remove the blank-spaces from the title and replace it with an underscore
      fileName += ReportTitle.replace(/ /g, '_')

      // Initialize file format you want csv or xls
      var uri = 'data:text/csv;charset=utf-8,' + escape(CSV)

      // Now the little tricky part.
      // you can use either>> window.open(uri);
      // but this will not work in some browsers
      // or you will not get the correct file extension

      // this trick will generate a temp <a /> tag
      var link = document.createElement('a')
      link.href = uri

      // set the visibility hidden so it will not effect on your web-layout
      link.style = 'visibility:hidden'
      link.download = fileName + '.csv'

      // this part will append the anchor tag and remove it after automatic click
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }
}
</script>

<style scoped>
.table{
    margin: 6px;
}
input {
  outline: none;
  margin: 6px;
}

input {
  -webkit-appearance: textfield;
  box-sizing: content-box;
  -webkit-box-sizing: content-box;
  font-family: inherit;
  font-size: 14px;
}

input::-webkit-search-decoration,
input::-webkit-search-cancel-button {
  display: none;
}

input {
  padding: 5px 20px 5px 10px;
  width: 70px;

  -webkit-border-radius: 10em;
  -moz-border-radius: 10em;
  border-radius: 10em;

  -webkit-transition: all 0.4s;
  -moz-transition: all 0.4s;
  transition: all 0.4s;
}

input:focus {
  width: 130px;
  /* -webkit-box-shadow: 0 0 5px rgba(109, 207, 246, 0.5);
  -moz-box-shadow: 0 0 5px rgba(109, 207, 246, 0.5);
  box-shadow: 0 0 5px rgba(109, 207, 246, 0.5); */
}

.legend {
  height: 12px !important;
  width: 12px !important;
  position: relative;
}

.right-space {
  margin-right: 10px;
}

/* #table {
  min-height: 567px;
} */

.fab-btn-xs {
  height: 20px;
  width: 20px;
}

/* Theme */

/* .theme--dark input {
  background: #2a335a;
  color: #fff;
} */

.theme--light input {
  /* background: #fff;
  color: black; */
  border: solid 1px;
}

/* .theme--dark input:focus {
  background-color: #2a335a;
  border-color: #ccc;
}

.theme--light input:focus {
  background-color: white;
  border-color: #ccc;
} */

.theme--dark .avatar-bg {
  /* background-color: transparent; */
  /* border-color: #2a335a; */
  border-width: 1px;
  border-style: solid;
}

.theme--light .avatar-bg {
  /* border-color: lightgray; */
  border-width: 1px;
  border-style: solid;
}

/* .theme--dark #table {
  background-color: #242c50;
}

.theme--light #table {
  background-color: #fff !important;
}

input:-moz-placeholder {
  color: #9498aa;
}

input::-webkit-input-placeholder {
  color: #9498aa;
} */
</style>

<style>
.plant-datatable {
  max-height: 500px;
  overflow: auto;
  display: flex;
}

.theme--dark .plant-datatable th {
  z-index: 1;
  position: sticky;
  top: 0;
  /* color: #c2c6dc !important; */
  /* background: #222743 !important; */
}

.theme--light .plant-datatable th {
  z-index: 1;
  position: sticky;
  top: 0;
  /* color: #626262 !important;
  background: #f8f8f8 !important; */
}

/* Theme */

.theme--dark .legend-background {
  /* background-color: #1d2137; */
  padding: 4px;
}

/* .theme--light .legend-background {
  background-color: lightgray;
} */

.legend-background span {
  font-size: 9px;
}
</style>
